import { useRightPanel } from '@/components/layout/workspace/rightPanelContext';
import { HOME } from './model';
import { TimeGridExample } from './TimeGridExample';
export function ScheduleDemo() {
  const panel = useRightPanel();
  return (
    <TimeGridExample
      onShiftClick={(shift, trigger) =>
        panel.open(
          { id: shift.id, title: shift.title, path: HOME + '/shift/' + shift.id, eyebrow: 'Событие' },
          trigger,
        )
      }
    />
  );
}
